import { NgModule } from '@angular/core';
import { ToothEditorComponent } from './containers/tooth-editor/v1/tooth-editor.component';
import { CrownSectionComponent } from '@modules/tooth-editor/containers/crown-section/v1/crown-section.component';
import { ToothEditorSharedModule } from '@modules/tooth-editor/tooth-editor-shared.module';
import { MiniTeethDiagramComponent } from '@modules/tooth-editor/components/mini-teeth-diagram/v1/mini-teeth-diagram.component';
import { TlkModalWindowModule } from '@itero/ui-toolkit-angular/modal-window';
import { EmbeddedRemoteApplicationComponent } from '@itero/ui-toolkit-angular/remote-application';
import { ImplantPositionComponent } from './components/implant-position/implant-position.component';
import { ImplantsViewComponent } from '@shared/implants-view/implants-view.component';

@NgModule({
	declarations: [ToothEditorComponent, CrownSectionComponent, MiniTeethDiagramComponent],
	imports: [
		ToothEditorSharedModule,
		TlkModalWindowModule,
		EmbeddedRemoteApplicationComponent,
		ImplantPositionComponent,
		ImplantsViewComponent
	],
	exports: []
})
export class ToothEditorV1Module {}
